import React from 'react';

const ReviewNotes = ({ notes, status }) => {
  if (!notes) return null;
  
  const isRejected = status === 'rejected';
  
  return (
    <div className={`review-notes ${isRejected ? 'review-notes-rejected' : 'review-notes-revision'}`}>
      <div className="review-notes-header">
        <span className="review-notes-icon">
          {isRejected ? '✕' : '↻'}
        </span>
        <span className="review-notes-title">
          {isRejected ? 'Why this recording was not accepted' : 'What needs to be changed'}
        </span>
      </div>
      <p className="review-notes-content">{notes}</p>
    </div>
  );
};

export default ReviewNotes;
